import { useSelector } from 'react-redux';
import { StepsStyles } from '../StepsStyles';
import { useGetVendorsQuery } from 'features/vendor/vendorSlice';

const VendorOverview = ({ }) => {
    const classes = StepsStyles()

    const { accessToEdit } = useSelector(state => state.accessState);

    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();

    const vendorsLookup = vendors?.reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
    }, {});


    return (
        <>
            <div className={classes.overviewField}><label >Vendor Name: </label>{vendorsLookup[accessToEdit?.vendorId]?.name}</div>
        </>
    );
}

export default VendorOverview;